import { Grid } from "@mui/material";
import dataDetalles from "../data/dataDetalles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import SinDatos from "components/Carteles/SinDatos";
import DataTable from "components/DataTable";

const ListadoDetalles = ({ detalles, ejecutarAccion }) => {
  const [rows, setRows] = useState([]);
  const { columns, getRows } = dataDetalles;

  useEffect(() => {
    setRows(getRows(detalles, ejecutarAccion));
  }, [detalles]);

  if (!detalles || detalles?.length < 1) {
    return <SinDatos />;
  }
  return (
    <Grid
      sx={{
        maxHeight: "250px",
        overflowY: "auto",
      }}
    >
      <DataTable columns={columns} rows={rows} />
    </Grid>
  );
};

export default ListadoDetalles;

ListadoDetalles.propTypes = {
  detalles: PropTypes.array,
  ejecutarAccion: PropTypes.func,
};
